module.exports = __webpack_public_path__ + "static/media/61.2c55583b.jpg";